import NavigateBackWizardStep from "../../components/navigateBackWizardStep";
import { Link } from "react-router-dom";
import { useWizard } from "react-use-wizard";
import { useTranslation } from "react-i18next";
import moment from "moment";
import createPersistedState from "use-persisted-state";
import { getTranslatedClinicNameFromId } from "../../utils";
const useClinicState = createPersistedState("clinic");

function ConfirmWaitlistStep({ currentDate }) {
  const { nextStep, goToStep } = useWizard();
  const { t, i18n } = useTranslation();
  const [clinicId, setClinic] = useClinicState();

  const handleClick = () => {
    nextStep();
  };

  return (
    <>
      <NavigateBackWizardStep
        clickHandler={() => goToStep(2)}
        title={t("appointment.TIME.time")}
      />
      <div className="body_content py-3">
        <div className="inner_body">
          <div className="timeslot_block">
            <p className="txt_slot">
              {moment(new Date(currentDate.date)).format("Do MMMM YYYY, dddd")}
              <span className="txt_loc d-block">
                {getTranslatedClinicNameFromId(clinicId, t)}
              </span>
            </p>
            <p className="txt_slot">
              <strong>{t("appointment.CONFIRMED.doctor-name")}</strong>
            </p>
          </div>
          <div className="modal-body">
            <div className="content_modal text-center">
              <h6 className="txt_small">
                {i18n.language !== "hi" && i18n.language !== "mr" && (
                  <>
                    <>{t("appointment.WAITLIST.message1")}</>
                    <br />
                    <>
                      {" "}
                      {moment(new Date(currentDate.date)).format(
                        "Do MMMM YYYY"
                      )}
                    </>
                  </>
                )}
                {(i18n.language === "hi" || i18n.language === "mr") && (
                  <>
                    <>
                      {moment(new Date(currentDate.date)).format(
                        "Do MMMM YYYY"
                      )}
                    </>
                    <br />
                    <>{t("appointment.WAITLIST.message1")}</>
                  </>
                )}
              </h6>
              <div className="w-100 pb-5 pt-5 btn_block align-items-center justify-content-center">
                <Link
                  to="#"
                  className="btn btn_outline p-2 m-2  w-90"
                  onClick={() => goToStep(2)}
                >
                  <span>{t("appointment.WAITLIST.button2")}</span>
                </Link>
              </div>
            </div>
          </div>
          {moment(new Date(currentDate.date)).format("yyyy-MM-DD") !==
            moment().format("yyyy-MM-DD") && (
            <div className="w-100 pb-5 align-items-center justify-content-center d-none">
              <Link
                to="#"
                className="btn w-75 text-decoration-underline txt_color_orange m-5"
                onClick={handleClick}
              >
                {t("appointment.WAITLIST.button3")}
              </Link>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default ConfirmWaitlistStep;
